import moment from 'moment-timezone';
import { compose, withHandlers, lifecycle, withState, withPropsOnChange } from 'recompose';
import { connect } from 'react-redux';

import withToggle from '../common/hoc/withToggle';
import Queue from './components/Queue';
import { getJobsStatus, addJobToQueue } from './actions';
import { getPendingJobs, getFinishedJobs } from './selectors';
import {
  getActiveBrandId,
  getActiveShopId,
  getBarberUser,
  getShopBrand,
  getShopOrBarberField,
} from '../auth/selectors';
import withTimezone from '../auth/utils/withTimezone';
import withDateFormat from '../auth/utils/withDateFormat';
import withDateToString from '../common/hoc/withDateToString';
import { ChurnZeroService, DOWNLOAD_CLIENTS_LIST } from '../../modules/infra/observability/churnzero';
import config from '../../config';

const mapStateToProps = (state, ownProps) => {
  let defaultEmail = getShopOrBarberField(state, 'email');
  const brandId = getActiveBrandId(state);
  if (brandId) {
    defaultEmail = getShopBrand(state).email;
  }
  return {
    finishedJobs: getFinishedJobs(state, ownProps.jobName),
    pendingJobs: getPendingJobs(state, ownProps.jobName),
    shopId: getActiveShopId(state),
    barber: getBarberUser(state),
    defaultEmail,
    brandId,
  };
};

const mapDispatchToProps = {
  getJobs: getJobsStatus,
  addJob: addJobToQueue,
};

const defaultJobArgs = (props) => {
  const args = { shopId: props.shopId };
  if (props.barber) {
    args.barberId = props.barber.id;
  }

  if (props.brandId) {
    args.brandId = props.brandId;
  }

  return args;
};

const getFilterDate = (props, dateFieldName) => props.filters && props.filters[dateFieldName];
const getFilterDateMs = (props, dateFieldName) => {
  const filterDate = getFilterDate(props, dateFieldName);
  return filterDate && moment(filterDate).valueOf();
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withToggle('queueModal'),
  withTimezone,
  withDateFormat(),
  withState('showFinished', 'setShowFinished', false),
  withState('filterDates', 'setFilterDates', props => ({
    startDate: getFilterDate(props, 'startDate'),
    endDate: getFilterDate(props, 'endDate'),
  })),
  withHandlers({
    onFilterDatesChange: props => (startDate, endDate) => {
      props.setFilterDates({ startDate, endDate });
    },
  }),
  withPropsOnChange((prevProps, nextProps) => {
    const prevStartDate = getFilterDateMs(prevProps, 'startDate');
    const nextStartDate = getFilterDateMs(nextProps, 'startDate');
    const prevEndDate = getFilterDateMs(prevProps, 'endDate');
    const nextEndDate = getFilterDateMs(nextProps, 'endDate');

    return (nextStartDate !== prevStartDate || nextEndDate !== prevEndDate);
  }, (props) => {
    props.onFilterDatesChange(
      getFilterDate(props, 'startDate'),
      getFilterDate(props, 'endDate')
    );
  }),
  withHandlers({
    getAllJobs: props => () => props.getJobs(props.name, props.jobName, defaultJobArgs(props)),
  }),
  withHandlers({
    open: props => () => {
      props.getAllJobs();
      return props.queueModalOn();
    },
    refresh: props => () => props.getAllJobs(),
    close: props => () => props.queueModalOff(),
    add: props => (e) => {
      e.preventDefault();
      const email = e.target.elements.email.value;
      if (!email.trim()) {
        return false;
      }

      if (props.jobName === 'customer-report') {
        ChurnZeroService.track(DOWNLOAD_CLIENTS_LIST);
      }

      const filters = Object.assign({}, props.filters || {});

      if (props.filterDates.startDate && props.filterDates.endDate) {
        let startDate, endDate; // eslint-disable-line

        if (props.dateOnly) {
          startDate = moment(props.filterDates.startDate, props.dateFormat);
          endDate = moment(props.filterDates.endDate, props.dateFormat);
        } else if (typeof props.filterDates.startDate === 'string') {
          startDate = moment.tz(props.filterDates.startDate, props.dateFormat, props.timezone);
          endDate = moment.tz(props.filterDates.endDate, props.dateFormat, props.timezone);
        } else {
          startDate = moment.tz(props.filterDates.startDate, props.timezone);
          endDate = moment.tz(props.filterDates.endDate, props.timezone);
        }

        if (props.dateOnly) {
          filters.startDate = startDate.format(config.dateFormatISO);
          filters.endDate = endDate.format(config.dateFormatISO);
        } else {
          filters.startDate = startDate.startOf('day').toJSON();
          filters.endDate = endDate.endOf('day').toJSON();
        }
      }

      return props.addJob(props.name, props.jobName, {
        ...defaultJobArgs(props),
        ...filters,
        email,
      });
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getAllJobs();
    },
  }),
  withDateToString,
)(Queue);
